export default "__VITE_ASSET__BeCRlAkI__"